import { Filter, FilterType, FilterKey } from 'api-paths-cas';
import { orderBy } from 'lodash';
import { IGetFilterGroupsProps } from '../../types';

const key = FilterKey.COUNTRY_OF_RESIDENCE;
export const getCountryOfResidenceFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const residencyFilterOptions = filterOptions?.residency || [];

  const options = residencyFilterOptions.map(country => {
    return {
      label: country,
      value: country,
      checked: filters.some(filter => filter === country),
    };
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return {
    name: 'Country of residence',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: sortedOptions,
    },
  };
};
